import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useLocation } from "react-router-dom";
// * CSS
import './scenario.css';
// * Helpers
import { AMS } from "../../services/api";
import AuthContext from '../../context/Auth/AuthContext';
/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { BiArrowFromRight } from "react-icons/bi";
// Matrix SpreadSheet control
import MatrixSpreadSheet from './matrixSpreadsheet';

//reusable treeView
import TreeViewGA from '../ReusableComponents/TreeViewGA/treeViewGA';



const MatrixControl = () => {
    /**We use the useTranslation hook to update the text when the language changes */
    const { t } = useTranslation('common');
    // Session context to get the current institution data
    const { get_user_from_session } = useContext(AuthContext);
    /**The useHistory hook allow us to redirect to another route */
    const history = useHistory();
    //* To can acess the parameters sent via history.push
    const location = useLocation();

    // * State used to save the selected Matrix (this in the Matrix Tree)
    const [selectedNodeData, setSelectedNodeData] = useState(null);

    //
    const [dataTree, setDataTree] = useState([]);

    //block tree when data is loading
    const [blockTree, setBlockTree] = useState(false);

    /**Triggered when user clicks "Go Back" button. Redirects to Scenarios view*/
    const goToScenarios = () => {
        // location.state.detail has current scenario information:
        // Example:
        //
        //   {
        //       code: "BORREME01"
        //       description: "Borreme"
        //       editLockUserCode: null
        //       finalYear: 2025
        //       institutionId: 0
        //       isCalculated: false
        //       isLock: false
        //       modelId: 4
        //       modelName: "Example 29.09.2021"
        //       name: "BORREME 01"
        //       path: null
        //       scenarioId: 89
        //   }
        //
        // it may used to pass the information back:
        //
        // history.push({
        //     pathname: '/Dashboard',
        //     state: {
        //         detail: location.state.detail 
        //     }
        // });
        history.push('/Scenarios');
    }

    // we use useEffect to set the states
    useEffect(() => {
        // Calls the funtion that gets the tree data
        getTreeJson();
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    const getTreeJson = async () => {
        //* call to API to get the tree json
        const response = await AMS.get(`/tree/SCENARIO/${location.state.detail.scenarioId}?usr=${get_user_from_session().user.email}`);
        //* Expand the selected node
        setDataTree(response.data.data);
    }

    //* Function used to set the state with the code of the selected matrix in the matrix tree
    //* Also gets the matrix data
    const getMatrixData = (matrixNoneData) => {

        if (matrixNoneData === null) {
            setSelectedNodeData(null);
            return;
        }

        // State variable with all selected node information
        setBlockTree(true);

        //generate initial selectors
        let selectors = "";
        if (matrixNoneData.type === 'matrix') {
            if (matrixNoneData.breadcrumb !== "") {
                const selectorsList = matrixNoneData.breadcrumb.split(',');
                const initialSelectors = selectorsList.map((item) => {
                    return `${item}=0`
                });
                selectors = initialSelectors.join(',');
            }
        }



        setSelectedNodeData({ ...matrixNoneData, initialSelectors: selectors });//! this triggers the useEffect of matrixSpreadSheeet

    }

    return (
        <>
            <div>
                <div className="sub_menu">
                    <div className="sub_menu_btns my-1">
                        <button className="ilo-btn wizard_goBack_btn" onClick={goToScenarios}> <BiArrowFromRight /> {t('scenarios.goBack')}</button>
                    </div>
                </div>
                <div className="container-fluid mt-1">
                    <div className="row container_grid">
                        <div className="col-sm-12 col-md-3 col-lg-3 matrix_tree_container">
                            {/**Shows the tree with the list of matrix*/}
                            <TreeViewGA
                                dataSource={dataTree}
                                defaultOpen={location.state.code}
                                blockTree={blockTree}
                                afterClickLeaf={getMatrixData}
                                searchingInTree={() => { getMatrixData(null) }}
                                useWideContainer={true}
                            />
                        </div>
                        <div className="col-sm-12 col-md-9 col-lg-9">
                            {
                                /**Shows the spreadsheet control that will show the matrix data*/
                                selectedNodeData === null ? <></> : <MatrixSpreadSheet selectedNodeData={selectedNodeData} setBlockTree={setBlockTree} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MatrixControl